import { Form, Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import React,{ useState,useRef,useCallback , useEffect} from 'react';
import FormContainer from '../components/FormContainer';
import { CusFormLabel, FormTitle, FormUploadView, TermsFormCheckboxNoErrMsgDisplay} from '../validation/Form-Components';
import { useHistory } from "react-router-dom";
import CusProgressBar from '../components/CusProgressBar';
import config from '../appconfig/config.json';
import service from '../services/ApiService.js';
import uploadService from '../services/UploadFilesService.js';
import Loading from '../components/Loading';
import CusRadioButton from '../components/CusRadioButton';
import { uploadTermsValidator } from '../validation/Validators';
import helper from '../factory/Helper.js';
import uploadConfig from '../data/uploaddetailsdata.json';
import storage from '../factory/StorageFactory';
import ImgPopup from '../components/ImgPopup';
import CusToast from '../components/CusToast';
import axios from 'axios';
import {  Error  } from '@progress/kendo-react-labels';
import ReactCrop from 'react-image-crop';
import '../styles/ReactCrop.css';
import {Button} from '@progress/kendo-react-buttons';
import cropper from '../factory/cropper';
import { isMobile } from 'react-device-detect';
import CusSignPad from '../components/CusSignPad';
 

const pdfFileNameCharRegex = new RegExp(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/);
 
let signatureId='0',pdfId='0',imgStr = '';


const NSUploadDetails = (props) => {
    var _URL = window.URL || window.webkitURL;
    let timer;
    const history = useHistory();
    const item = { bgcolor: "#389A6E", completed: 80 };
    const detailsType = '7';
    const seq0='0', seq1='1',seq2='2',seq3='3';

    const typeMemorandum ='Memorandum', typeSignature='Signature';
 
    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [checkedAdoptAcraTemplate,setCheckedAdoptAcraTemplate] = useState('N');
 
    const [selectedPdf, setSelectedPdf] = useState([]);
    const [selectedSignature, setSelectedSignature] = useState([]);

    const [isSaveSignDone, setIsSaveSignDone] = useState(false);
    const [isSavePdfDone, setIsSavePdfDone] = useState(false);
    const [uploadedPdf,setUploadedPdf] = useState();
    const [uploadedSignature,setUploadedSignature] = useState();
    const [showImgPopup,setShowImgPopup] = useState(false);

    const [initFormData, setInitFormData] = useState({DocClare:false});

    const [uploadPdfErr,setUploadPdfErr] = useState(false);
    const [pdfErrMsg,setPdfErrMsg] = useState('');

    const [uploadSignErr,setUploadSignErr] = useState(false);
    const [signErrMsg,setSignErrMsg] = useState('');
   

    //crop
    const [imgExt,setImgExt] = useState();
    const [upImg, setUpImg] = useState();
    const imgRef = useRef(null);
    const previewCanvasRef = useRef(null);
    const percentCrop ={unit: '%', width: 80, height:55, x:10, y:20};
    const mobileCrop ={unit: '%', width: 90, height:80, x:5, y:10};
    const [crop, setCrop] = useState(isMobile? mobileCrop:percentCrop);
    const [completedCrop, setCompletedCrop] = useState(null);
    const [signFile,setSignFile] = useState([]);
    const [buttonPopup, setButtonPopup] = useState(false);

    //signpad
    const sigPad = useRef(null);
    let datafromsignPad;

    const initResState = {
        RefNum:'',
        CompDtls:{}, 
        ApplicantDtls:[],
        ApplicantsDtlsMyInfo:{},
        DocSubmit:{}
    }
    const [response, setResponse] = useState(initResState);

    useEffect(() => {
        console.log('@NSUploadDetails useEffect');
    
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }

        window.scrollTo(0,0);
 
        getData();
        return () => clearTimeout(timer);
     }, []);
   
    const getData = () => {
        service.get().then( res => {
            if(res.data.isSucess) {
                bindFormData(res.data.model.fields.request);
                bindDocClare(res.data.model.fields.request);
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err=>{
            setIsLoading(false);
        })
    }

    const bindDocClare = (data) => {
  
        if(data.DocSubmit.DocClare !== undefined) {
            setInitFormData({DocClare:getBindDocClare(data) === 'true'? true:false})
        }
        else {
            setInitFormData({DocClare:false})
        }
    }

    const getBindDocClare = (data) => {
        if(getLoginUserOrder(data) === seq0) {
            return data.DocSubmit.DocClare.AuthPerSeq0;
        }
        if(getLoginUserOrder(data) === seq1) {
            return data.DocSubmit.DocClare.AuthPerSeq1;
        }
        if(getLoginUserOrder(data) === seq2) {
            return data.DocSubmit.DocClare.AuthPerSeq2;
        }
        if(getLoginUserOrder(data) === seq3) {
            return data.DocSubmit.DocClare.AuthPerSeq3;
        }
    }

    const bindFormData = (data) => {
         
        try{
            setResponse(data);  //asign api response
            if(isCompTypeDefault()) {
               
                setCheckedAdoptAcraTemplate(data.DocSubmit.AdoptAcraTemplate);
                if(data.DocSubmit.Doc) {
                    setIsSaveSignDone(true);
                    setIsSavePdfDone(true);
                    if(!Array.isArray(data.DocSubmit.Doc)) { //obj
                        if(data.DocSubmit.Doc.DocType === typeSignature){
                            if(data.DocSubmit.Doc.NRIC === data.ApplicantsDtlsMyInfo.IDNum) { 
                                signatureId =data.DocSubmit.Doc.id;
                                setSelectedSignature(getDefFileArray(data.DocSubmit.Doc.File));
                                setUploadedSignature(data.DocSubmit.Doc.File);
                            }
                            else {
                                signatureId='0';
                                setSelectedSignature([]);
                            } 
                        }
                        else if(data.DocSubmit.Doc.DocType === typeMemorandum) {
                            pdfId = data.DocSubmit.Doc.id;
                            setSelectedPdf(getDefFileArray(data.DocSubmit.Doc.File));
                            setUploadedPdf(data.DocSubmit.Doc.File)
                        }
                        else {
                            signatureId='0';
                            pdfId='0';
                        }
                    }
                    else { //array
                        let docArray = data.DocSubmit.Doc;
                        for(let i in docArray) {
                            if(docArray[i].DocType === typeMemorandum) {  //Memorandum is only one 
                                pdfId = docArray[i].id;
                                setSelectedPdf(getDefFileArray(docArray[i].File));
                                setUploadedPdf(docArray[i].File);
                            }
    
                            if(docArray[i].DocType === typeSignature) {
                                if(docArray[i].NRIC === data.ApplicantsDtlsMyInfo.IDNum) { 
                                    signatureId = docArray[i].id;
                                    setSelectedSignature(getDefFileArray(docArray[i].File));
                                    setUploadedSignature(docArray[i].File);
                                }
                            }
                        }
                    }
                }
                else {
                    signatureId = '0';
                    pdfId = '0';
                    setIsSaveSignDone(false);
                    setIsSavePdfDone(false);
                }
            }
            else {
           
                if(!checkNonAuthPerson(data)){  //only Sign
                    if(data.DocSubmit.Doc) {
                        setIsSaveSignDone(true);
                        if(!Array.isArray(data.DocSubmit.Doc)) { 
                            if(data.DocSubmit.Doc.DocType === typeSignature){
                                if(data.DocSubmit.Doc.NRIC === data.ApplicantsDtlsMyInfo.IDNum) { 
                                    signatureId =data.DocSubmit.Doc.id;
                                    setSelectedSignature(getDefFileArray(data.DocSubmit.Doc.File));
                                    setUploadedSignature(data.DocSubmit.Doc.File);
                                }
                                else {
                                    signatureId='0';
                                    setSelectedSignature([]);
                                } 
                            }
                        }
                        else {
                            let docArray = data.DocSubmit.Doc;
                            for(let i in docArray) {
                                if(docArray[i].DocType === typeSignature){
                                    if(docArray[i].NRIC === data.ApplicantsDtlsMyInfo.IDNum) { 
                                        signatureId = docArray[i].id;
                                        setSelectedSignature(getDefFileArray(docArray[i].File));
                                        setUploadedSignature(docArray[i].File);
                                    }
                                }
                            }
                        }
                    }
                    else {
                        signatureId = '0';
                        setIsSaveSignDone(false);
                    }
                }
            }
          
        }catch(ex) {

        }

        setIsLoading(false);
    }

    const getDefFileArray = (file) => {
        let fileArray = [];
        let fileData = {
            extension:file.extension,
            name:file.name,
            progress: parseInt(file.progress),
            size: parseInt(file.size) ,
            status:parseInt(file.status),
            uid:file.uid
        }
        fileArray.push(fileData);

        return fileArray;
    }

    const isNonAuthPerson = () => {
        let applicantArray = [];
        if(response.ApplicantDtls.length === undefined){
            applicantArray.push(response.ApplicantDtls);
        }
        else {
            applicantArray = response.ApplicantDtls;
        } 

        if(response.ApplicantsDtlsMyInfo){
            const authPerson = helper.getObjInArraybyIDNum(response.ApplicantsDtlsMyInfo.IDNum,applicantArray);
   
            if(authPerson === undefined){  //non auth person
                return true;
            }
            else if(authPerson.ApplicantSeq === seq0) { // non auth person
                return true;
            }
            else {  
                return false;
            }
        }
    }

    const checkNonAuthPerson = (data) => {
       
        let applicantArray = [];
        if(data.ApplicantDtls.length === undefined){
            applicantArray.push(data.ApplicantDtls);
        }
        else {
            applicantArray = data.ApplicantDtls;
        } 

        if(data.ApplicantsDtlsMyInfo){
            const authPerson = helper.getObjInArraybyIDNum(data.ApplicantsDtlsMyInfo.IDNum,applicantArray);
     
            if(authPerson === undefined){  //non auth person
                return true;
            }
            else if(authPerson.ApplicantSeq === seq0){ // non auth person
           
                return true;
            }
            else {
           
                return false;
            }
        }
    }

    const isFirstUser = () => {
        if(response.ApplicantsDtlsMyInfo){
            if(response.ApplicantsDtlsMyInfo.isFirstUser === "true"){  
                return true;
            }
            else {
                return false;
            }
        }
        return false;
    }

     
 
    const handleSubmit = (dataItem) => {

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }

        if(uploadSignErr) {
            showErrMsg(config.error.UploadDetails.SignCropFailed);
            return;
        }
        
        saveUploadDetails();
    }
 

    const uploadSignature = (file) => {
        setIsUploading(true);
        let signRawFile = file[0].getRawFile();
        let signName = response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+file[0].extension;
        uploadService.uploadFiles(signRawFile,response.RefNum,signName,typeSignature,signatureId)
        .then( res => {
            let resData = res.data;
            if(resData.isSucess){
                signatureId = resData.model.id;
                let fileParams = {
                    DocType: typeSignature,
                    DocName: signName,
                    NRIC:response.ApplicantsDtlsMyInfo.IDNum,
                    Name:response.ApplicantsDtlsMyInfo.Name,
                    id:signatureId,
                    File:{
                        extension:file[0].extension,
                        name:file[0].name,
                        progress:file[0].progress,
                        size: file[0].size,
                        status: file[0].status,
                        uid: file[0].uid
                    }
                };

                saveSignature(fileParams);
            }
            else{
                setIsUploading(false);
                showErrMsg(config.error.UploadDetails.UploadFailed);
                showSignErrMsg(config.error.UploadDetails.UploadFailed);
            }
        }).catch(err => {
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showSignErrMsg(config.error.UploadDetails.UploadFailed);
        })
    }

    const saveSignature = (signParams) => {
   
        let docArray = [];
        docArray.push(signParams);
      

        if(isFirstUser()) {  // only first user will upload memorandum
            if(selectedPdf.length !== 0) {
                let pdf = {
                    DocType: typeMemorandum,
                    DocName: response.RefNum+'_'+typeMemorandum+selectedPdf[0].extension,
                    id:pdfId,
                    File: {
                        extension:selectedPdf[0].extension,
                        name:selectedPdf[0].name,
                        progress:selectedPdf[0].progress,
                        size: selectedPdf[0].size,
                        status: selectedPdf[0].status,
                        uid: selectedPdf[0].uid
                    }
                }
                docArray.push(pdf);
            }
        }

        let params = {
            DocSubmit:{
                AdoptAcraTemplate:isCompTypeDefault()?checkedAdoptAcraTemplate:null,
                Doc: docArray,
                DocClare:false
            },
            CurrentUser:currentUser(),
      
        }
        service.post(detailsType,params).then( res => {
            setIsUploading(false);  
            let resData = res.data;
            if(resData.isSucess) {
                setIsSaveSignDone(true);
                setUploadedSignature(params.DocSubmit.Doc[0].File);
                hideSignErrMsg();
                setButtonPopup(false);
            }
            else {
                resetSignPad();
                resetSignature();
                showErrMsg(config.error.UploadDetails.UploadFailed);
                showSignErrMsg(config.error.UploadDetails.UploadFailed);
                setButtonPopup(false);
            }  
        })
        .catch(err => {
            // console.log('err',err)
            resetSignPad();
            resetSignature();
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showSignErrMsg(config.error.UploadDetails.UploadFailed);
            setButtonPopup(false);
        });
    }

    const resetSignature = () => {
        setIsSaveSignDone(false);
        setSelectedSignature([]);
        setUploadedSignature([]);
    }

    const uploadPdf = (pdfFile) => {
     
        setIsUploading(true);
        let rawFile = pdfFile[0].getRawFile();
        let docName = response.RefNum+'_'+typeMemorandum+pdfFile[0].extension; 
        uploadService.uploadFiles(rawFile,response.RefNum,docName,typeMemorandum,pdfId)
        .then( res => {
            let resData = res.data;
            if(resData.isSucess) {
                pdfId= resData.model.id;
                savePdfDoc(pdfFile);
                hidePdfErrMsg();
            }
            else{
                resetPdf();
                setIsUploading(false);
                showErrMsg(config.error.UploadDetails.UploadFailed);
                showPdfErrMsg(config.error.UploadDetails.UploadFailed);
            }
        }).catch(err => {
            resetPdf();
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showPdfErrMsg(config.error.UploadDetails.UploadFailed);
        })
    }

    const savePdfDoc = (pdfFile) => {
        let docArray = [];
        if(selectedSignature.length !== 0){
            let sign = {
                DocType: typeSignature,
                DocName: response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+selectedSignature[0].extension,
                NRIC:response.ApplicantsDtlsMyInfo.IDNum,
                Name:response.ApplicantsDtlsMyInfo.Name,
                id:signatureId,
                File:{
                    extension:selectedSignature[0].extension,
                    name:selectedSignature[0].name,
                    progress:selectedSignature[0].progress,
                    size: selectedSignature[0].size,
                    status: selectedSignature[0].status,
                    uid: selectedSignature[0].uid
                }
            }
            docArray.push(sign);
        }

        let pdfDoc = {
            DocType: typeMemorandum,
            DocName: response.RefNum+'_'+typeMemorandum+pdfFile[0].extension,
            id:pdfId,
            File: {
                extension:pdfFile[0].extension,
                name:pdfFile[0].name,
                progress:pdfFile[0].progress,
                size: pdfFile[0].size,
                status: pdfFile[0].status,
                uid: pdfFile[0].uid
            }
        }

        docArray.push(pdfDoc);

        let params = {
            DocSubmit:{
                AdoptAcraTemplate:isCompTypeDefault()?checkedAdoptAcraTemplate:null,
                Doc:docArray,
                DocClare:false
            },
            CurrentUser:currentUser()
        }

        service.post(detailsType,params).then( res => {
            setIsUploading(false);
            let resData = res.data;
            if(resData.isSucess) {
                setIsSavePdfDone(true);
                setUploadedPdf(pdfDoc.File);
            }
            else {
                resetPdf();
                showErrMsg(config.error.UploadDetails.UploadFailed);
            }          
        })
        .catch(err => {
            // console.log('savePdfDoc err: ',err);
            resetPdf();
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
        });
    }
    
    const resetPdf = () => {
        setIsSavePdfDone(false);
        setSelectedPdf([]);
    }

    const saveUploadDetails = () => {

        let params = {
            DocSubmit:{
                AdoptAcraTemplate:isCompTypeDefault()?checkedAdoptAcraTemplate:null,
                Doc: getDocArray(),
                DocClare:formatDocClare()
            },
            CurrentUser:currentUser()
        }
        setIsUploading(true);
        service.post(detailsType,params).then( res => {
            setIsUploading(false);
            let resData = res.data;
            if(resData.isSucess) {
                goNext();
            }
            else {
                showErrMsg(config.error.UploadDetails.UploadFailed);
            }          
        })
        .catch(err => {
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
        });
    }

    const formatDocClare = () => {
        let params = {
            AuthPerSeq0:getLoginUserOrder(response) === seq0? isCompTypeDefault()? true:false:false,
            AuthPerSeq1:getLoginUserOrder(response) === seq1? isCompTypeDefault()? true:false:false,
            AuthPerSeq2:getLoginUserOrder(response) === seq2? isCompTypeDefault()? true:false:false,
            AuthPerSeq3:getLoginUserOrder(response) === seq3? isCompTypeDefault()? true:false:false
        };

        return params;
    }
   
    const getDocArray = () => {
        let docArray = []; 
        if(isCompTypeDefault()) {  
             //current login user selected files
             if(selectedSignature.length !== 0){
                let sign = {
                    DocType: typeSignature,
                    DocName: response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+uploadedSignature.extension,
                    NRIC:response.ApplicantsDtlsMyInfo.IDNum,
                    Name:response.ApplicantsDtlsMyInfo.Name,
                    id:signatureId,
                    File:{
                        extension:uploadedSignature.extension,
                        name:uploadedSignature.name,
                        progress:uploadedSignature.progress,
                        size: uploadedSignature.size,
                        status: uploadedSignature.status,
                        uid: uploadedSignature.uid
                    }
                }
                docArray.push(sign);
            }

            if(isFirstUser()) {  // only first user will upload memorandum
                if(selectedPdf.length !== 0) {
                    let pdf = {
                        DocType: typeMemorandum,
                        DocName: response.RefNum+'_'+typeMemorandum+selectedPdf[0].extension,
                        id:pdfId,
                        File: {
                            extension:selectedPdf[0].extension,
                            name:selectedPdf[0].name,
                            progress:selectedPdf[0].progress,
                            size: selectedPdf[0].size,
                            status: selectedPdf[0].status,
                            uid: selectedPdf[0].uid
                        }
                    }
                    docArray.push(pdf);
                }
            }
        }
        else {
            if(selectedSignature.length !== 0){
                let sign = {
                    DocType: typeSignature,
                    DocName: response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+selectedSignature[0].extension,
                    NRIC:response.ApplicantsDtlsMyInfo.IDNum,
                    Name:response.ApplicantsDtlsMyInfo.Name,
                    id:signatureId,
                    File:{
                        extension:selectedSignature[0].extension,
                        name:selectedSignature[0].name,
                        progress:selectedSignature[0].progress,
                        size: selectedSignature[0].size,
                        status: selectedSignature[0].status,
                        uid: selectedSignature[0].uid
                    }
                }
                docArray.push(sign);
            }
        }
        return docArray;
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
            else {
                if(getLoginUserOrder(response) === '0') {
                    history.push(config.route.NonAuthPersonDetails, { from: config.route.NSUploadDetails });
                }
                else {
                    if(isFirstUser()){
                        history.push(config.route.AcctOpeningMY, { from: config.route.NSUploadDetails});
                    }
                    else{
                        history.push(config.route.DeclarationDetails, { from: config.route.NSUploadDetails });
                    }
                }
            }
        }
        else {
            if(getLoginUserOrder(response) === '0') {
                history.push(config.route.NonAuthPersonDetails, { from: config.route.NSUploadDetails});
            }
            else {
                if(isFirstUser()){
                    history.push(config.route.AcctOpeningMY, { from: config.route.NSUploadDetails});
                }
                else{
                    history.push(config.route.DeclarationDetails, { from: config.route.NSUploadDetails});
                }
            }
            
        }
    }

    const disabledNextBtn = () => {
        let disable = true;
        if(!isCompTypeDefault()) {
            if(isNonAuthPerson()) {
                disable = false;
            }
            else if(selectedSignature.length !== 0  ) {  //director or holders
                disable = false;
            }
            else {
                disable = true;
            }
        }
        else if(!isNonAuthPerson()) { //First User, Authorised Person
            if(selectedSignature.length !== 0 && selectedPdf.length !== 0) {  //director or holders
                disable = false;
            }
            else {
                disable = true;
            }
        }
        else { //Non authorised Person
            if(selectedPdf.length !== 0) {
                disable = false;
            }
            else {
                disable = true;
            }
        }
      
        return disable;
    }

    const currentUser = () => {
        let params = {};
        params = {
            IDNum: response.ApplicantsDtlsMyInfo.IDNum,
            Seq:getLoginUserSeq(),
            Order:getLoginUserOrder(response)
        }
        return params
    }

    const getLoginUserOrder = (resObj) => {
        let authSeq = '', isAuthPerson = false;
        if(!Array.isArray(resObj.ApplicantDtls)){ //check obj or array
            if(resObj.ApplicantDtls.IDNum ===  resObj.ApplicantsDtlsMyInfo.IDNum){
                authSeq = resObj.ApplicantDtls.ApplicantSeq;
                isAuthPerson = true;
            }
            else {  //non login user
                authSeq = '0';
                isAuthPerson = false;
            }
        }
        else { //array
            for(let i in resObj.ApplicantDtls) {
                if(resObj.ApplicantDtls[i].IDNum ===  resObj.ApplicantsDtlsMyInfo.IDNum) {  // get login user's seq number 
                    authSeq = resObj.ApplicantDtls[i].ApplicantSeq;
                    isAuthPerson = true;
                }
            }
        }
        
        if(isAuthPerson){
            return authSeq;
        }
        else {
            return '0';
        }
    }

    const getLoginUserSeq = () => {
        if(isFirstUser()){  // first user
            return '0';
        }
        else {  // not first user
            if(!Array.isArray(response.ApplicantDtls)){ //check obj
                if(response.ApplicantDtls.IDNum ===  response.ApplicantsDtlsMyInfo.IDNum){
                    return response.ApplicantDtls.ApplicantSeq;
                }
            }
            else { //array
                for(let i in response.ApplicantDtls){
                    if(response.ApplicantDtls[i].IDNum ===  response.ApplicantsDtlsMyInfo.IDNum){
                        return response.ApplicantDtls[i].ApplicantSeq;
                    }
                }
            }
        }
    }
 
    const isValidSignature = (file) => {
 
        let isValid = false;
        try{
            if(file.length !== 0) {
                let fileObj = file[0];
          
                let size = fileObj.size;
                let extn = fileObj.extension.toLowerCase();
                if(extn === '.png' || extn === '.jpg' || extn === '.jpeg') {
                    if(size <= 3145728) {
                        isValid = true;
                    }
                    else {
                        isValid = false;
                    }
                }
                else {
                    isValid = false;
                }
            }
            else{
                isValid = false;
            }
            return isValid;
        }catch(ex){
        
        }
      

        return isValid;
    }
 

    const isValidPdf = (pdfFile) => {
        let isValid = false;
        try{
            if(pdfFile.length !== 0) {
                let fileObj = pdfFile[0];
                let size = fileObj.size;
                let extn = fileObj.extension.toLowerCase();
                if(extn === '.pdf') {
                    if(size <= 5242880) {
                        isValid = true;
                    } 
                    else {
                        isValid = false;
                    }
                 }
                 else {
                    isValid = false;
                 }
            }
            else{
                isValid = false;
            }
            return isValid;
        }catch(ex){
        
        }

        return isValid;
    }

    
    const isValidPdfFileName = (pdfFile) => {

        let fileObj = pdfFile[0];
        let fileName = fileObj.name;
        let isValid = true;
        if(pdfFileNameCharRegex.test(fileName)) {
            isValid = false;
        }
        return isValid;
    }


    const onHandleChange = (data) => {
        hideSignErrMsg();
        // resetSignature();
     
        setSelectedSignature(data.value);

        setCrop(isMobile? mobileCrop:percentCrop);
        setSignFile(data.value);

        if(data.value.length !== 0) {
    
            if(!isValidSignature(data.value)) { 
                showErrMsg(uploadConfig.errMsg.imgSize3MB);
                showSignErrMsg(uploadConfig.errMsg.imgSize3MB);
                resetSignature();
                return;
            }
            
            if(!config.EnableSignatureCropping){  //signature cropping disable
                uploadSignature(data.value);
            }
            else {   //signature cropping enable
                var vfile, img;
                if ((vfile = data.value[0])) {
                    img = new Image();
                    var objectUrl = _URL.createObjectURL(data.value[0].getRawFile());
                        img.onload = function () {
                            if(this.width < 640 || this.height < 480) {
                                showErrMsg('Your signature image is ('+this.width+'px X '+this.height+'px) dimension. '+uploadConfig.errMsg.minImgDimension);
                                showSignErrMsg('Your signature image is ('+this.width+'px X '+this.height+'px) dimension. '+uploadConfig.errMsg.minImgDimension);
                                resetSignature();
                            }
                            else {
                                cropSignature(data);
                            }
                     
                            _URL.revokeObjectURL(objectUrl);
                        };
                    img.src = objectUrl;
                }
            }
        } 
    }

    const onHandlePdfDocChange = (data) =>{
        setSelectedPdf(data.value)
        if(data.value.length === 0){
            hidePdfErrMsg();
        } 

        if(data.value.length !== 0) {
        
            if(!isValidPdf(data.value)){
                resetPdf();
                showErrMsg(uploadConfig.errMsg.pdfSize5MB);
                showPdfErrMsg(uploadConfig.errMsg.pdfSize5MB);
                return;
            }

            if(!isValidPdfFileName(data.value)) {
                resetPdf();
                showErrMsg(uploadConfig.errMsg.pdfNameSpecChars);
                showPdfErrMsg(uploadConfig.errMsg.pdfNameSpecChars);
                return;
            }

            let fContent = data.value[0].getRawFile();
            let fdata;
            if(fContent){
                let reader = new FileReader();
                reader.readAsText(fContent, "UTF-8");
                reader.onload = function (evt) {
                    fdata = evt.target.result;
                
                    if (fdata != "" &&  fdata.indexOf("Encrypt") > 0) {
                        resetPdf();
                        showErrMsg(uploadConfig.errMsg.encryptedPdf);
                        showPdfErrMsg(uploadConfig.errMsg.encryptedPdf);
                    }
                    else {
                        uploadPdf(data.value);
                    }
                }
            }
        }
    }

    const onAdoptAcraTemplateChange = (e) => {
        setCheckedAdoptAcraTemplate(e.value);
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const showPdfErrMsg = (msg) => {
        setUploadPdfErr(true);
        setPdfErrMsg(msg)
    }
    
    const hidePdfErrMsg = () => {
        setUploadPdfErr(false);
        setPdfErrMsg('');
    }

    const showSignErrMsg = (msg) => {
        setUploadSignErr(true);
        setSignErrMsg(msg);
    }
    
    const hideSignErrMsg = () => {
        setUploadSignErr(false);
        setSignErrMsg('');
    }

    const getAuthPerName = () =>{
        if(response.ApplicantsDtlsMyInfo.Name !==null) { //always login user
           return '(Authorised Person '+getLoginUserOrder(response)+' - '+response.ApplicantsDtlsMyInfo.Name+')';
        }
        else {
            return '';
        }
    }

    const isCompTypeDefault = () => {
        if(storage.getCompType() === uploadConfig.SCOType.SCO4) {
            return false;
        }
 
        return true;
    }

    const handleBackBtnClick = (e) =>{
        e.preventDefault();
        if(isFirstUser()){
            history.push(config.route.NSTaxDetails);
        }
        else {
            if(!isFirstUser()){
                history.push(config.route.NSDelegationDetails);
            }
            else {
                history.push(config.route.NSDelegationDetails2);
            }
        }
    }

    const downloadPdf = (refNo,docType,docId,docName) => {
       
       const pdfUrl = uploadService.getPdfFileUrl(refNo,docType,docId,docName);
        //window.open(pdfUrl);
 
        axios({
            url: pdfUrl, //your url
            method: 'GET',
            responseType: 'blob', // important
            headers: {
                "Content-Type": "application/octet-stream",
                'Authorization': "Maybank" + " " +storage.getToken()
            }
        }).then((response) => {
            const dFileName = docName+".pdf"
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', dFileName ); //or any other extension
            document.body.appendChild(link);
            link.click();
        });
    }
    
    const getUploadFile = (refNo,docType,docId) => {
   
        setIsUploading(true);
        uploadService.getFile(refNo,docType,docId).then( res => {
            if(res.data.isSucess) {
                setIsUploading(false);
                if(docType === typeMemorandum) {  //pdf
                    let pdfWindow = window.open("")
                    // pdfWindow.document.write(
                    //     "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                    //     encodeURI(res.data.model.imageFields) + "'></iframe>" )
                    pdfWindow.document.write("<html<head><title>"+uploadedPdf.name+"</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");
                    pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(res.data.model.imageFields)+"#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>");
                }
                else { //signature img
                    imgStr = 'data:image/png;base64,'+res.data.model.imageFields;
                    setShowImgPopup(true);
                }
            }
            else{
                setIsUploading(false);
            }
        })
        .catch(err=>{
            // console.log('@getUploadFile: ',err);
            setIsUploading(false);
        })
    }

    //crop signature
    const isValidCropImg = (completedCrop) => {
        let valid = true;
        let width = completedCrop.width.toFixed();
        let height = completedCrop.height.toFixed();
        if(width < 250 && height < 250) {
            showErrMsg(uploadConfig.errMsg.cropImgSmall);
            valid = false;
        }
        else if(width > 400 && height > 400) {
             showErrMsg(uploadConfig.errMsg.cropImgLarge);
            valid = false;
        }
        else {
            valid = true;
        }
        return valid;
    }

    const cropSignature = (data) => {
        setButtonPopup(true);
    
        let fContent = data.value[0].getRawFile();
   
        let reader = new FileReader();
        reader.addEventListener('load', () => {
            setUpImg(reader.result);
            setImgExt(helper.extractImgFileExtensionFromBase64(reader.result));
        });
        reader.readAsDataURL(fContent);
    }

    const onLoad = useCallback((img) => {
        imgRef.current = img;
    }, []);
  
      const cancelImgCrop = (e) => {
        e.preventDefault();
        setButtonPopup(false);
        setCrop(isMobile? mobileCrop:percentCrop);
        showSignErrMsg(config.error.UploadDetails.SignCropFailed);
    }
  
      const saveImgCrop = (e) => {
        
        e.preventDefault();
        if(!previewCanvasRef.current || !completedCrop) {
          return;
        }

        if(!isMobile) {
            if(!isValidCropImg(completedCrop)){
                return;
            }
        }
 
        const canvas = cropper.getCroppedImg(completedCrop, previewCanvasRef,imgRef);
        const base64Image = cropper.getResizeb64Img(completedCrop,canvas,imgExt);

        let binaryFile = helper.dataURLtoFile(base64Image,signFile[0].name);
        let docName = response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+signFile[0].extension;

        setIsUploading(true);
     
        uploadService.uploadFiles(binaryFile,response.RefNum,docName,typeSignature,signatureId)
         .then( res => {
             let resData = res.data;
             if(resData.isSucess){
               
                 signatureId = resData.model.id;
                 let fileParams = {
                    DocType: typeSignature,
                    DocName: docName,
                    NRIC:response.ApplicantsDtlsMyInfo.IDNum,
                    Name:response.ApplicantsDtlsMyInfo.Name,
                    id:signatureId,
                    File:{
                        extension:signFile[0].extension,
                        name:signFile[0].name,
                        progress:signFile[0].progress,
                        size: signFile[0].size,
                        status: signFile[0].status,
                        uid: signFile[0].uid
                    }
                 };

                 setSelectedSignature(getDefFileArray(fileParams.File));

                 saveSignature(fileParams);
             }
             else{
                 setIsUploading(false);
                 showErrMsg(config.error.UploadDetails.UploadFailed);
                 showSignErrMsg(config.error.UploadDetails.UploadFailed);
             }
         }).catch(err => {
           
             setIsUploading(false);
             showErrMsg(config.error.UploadDetails.UploadFailed);
             showSignErrMsg(config.error.UploadDetails.UploadFailed);
         })
      }
      //crop signature end

       //sign pad start
       const clearSignPad = (e) => {
        e.preventDefault();
        resetSignPad();
        hideSignErrMsg();
      }

      const resetSignPad = () => {
        if(isMobile){
            sigPad.current.clear();
        }
      }

      const saveSignPad = (e) => {
        e.preventDefault();
        if (sigPad.current.isEmpty()) {
            showErrMsg("Please provide your e-sign.");
            showSignErrMsg("Please provide your e-sign.");
            return;
        } else {
            setIsUploading(true);
            datafromsignPad = sigPad.current.getTrimmedCanvas().toDataURL();
            datafromsignPad = datafromsignPad.replace(/^data:image\/[a-z]+;base64,/, "");
            uploadSignPadImg(datafromsignPad);
        }
      }

      const handleViewSignImg = (e)=> {
        e.preventDefault();
        getUploadFile(response.RefNum,typeSignature,signatureId);
      }

      const uploadSignPadImg = (b64ImgData) => {
 
        let docName = response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+'.png';
        uploadService.uploadB64ImgFile(b64ImgData,response.RefNum,docName,typeSignature,'png',signatureId)
        .then( res => {
            let resData = res.data;
            if(resData.isSucess) { 
                signatureId = resData.model.id;
                let doc = {
                    DocType: typeSignature,
                    DocName: docName,
                    id: signatureId,
                    NRIC:response.ApplicantsDtlsMyInfo.IDNum,
                    Name:response.ApplicantsDtlsMyInfo.Name,
                    File:{
                        extension:'.png',
                        name: signatureId+'_'+typeSignature+'.png',
                        progress:0,
                        size:signatureId,
                        status: 2,
                        uid: response.RefNum
                    }
                }

                setSelectedSignature(getDefFileArray(doc.File));
                setUploadedSignature(doc.File);
                saveSignature(doc);
            }
            else{
                resetSignPad();
                setIsUploading(false);
                showErrMsg(config.error.UploadDetails.UploadFailed);
                showSignErrMsg(config.error.UploadDetails.UploadFailed);
            }
        }).catch(err => {
            // console.log(err);
            resetSignPad();
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showSignErrMsg(config.error.UploadDetails.UploadFailed);
        })
      }
      //sign pad end
    
    if(isLoading) {
        return(
            <Loading />
        )
    }
    
    return(
        <div className="container-fluid">
           <div className="outerdivsubheader">
                <div className="row">
                    <div className="col-12">
                        <h2 className='welcome mb-0'>Business Account Opening<br/>SME Banking</h2>
                    </div>
                </div>
            </div> <br/>
            <Form onSubmitClick={handleSubmit}
                initialValues={initFormData}
                key={JSON.stringify(initFormData)}
                render={(formRenderProps)=>(
                <FormElement>
                <FormContainer>
                    <fieldset>
                        <Field component={FormTitle} id={'ft1'} name={'Your Additional Business Details'}/> 
                        <FieldWrapper style={{paddingBottom:'20px'}}>
                            <Field component={CusFormLabel} 
                                leftLabelId={'lblCapAmt'} leftLabelName={'Issued Capital Amount (Ordinary Shares)'}
                                id={'CapAmt'} name={response.CompDtls.IssuedCapitalAmount !=="null"? response.CompDtls.IssuedCapitalAmount:'Not applicable'} />
                            <Field component={CusFormLabel} 
                                leftLabelId={'lblBizName'} leftLabelName={'Business Former Name'}
                                id={'BizName'} name={response.CompDtls.FormerName !==null?response.CompDtls.FormerName:'Not applicable'} />
                        </FieldWrapper>
                    </fieldset>
                </FormContainer>

                <FormContainer>
                    <fieldset>
                        <Field component={FormTitle} id={'ft2'} name={'Upload Supporting Documents'} />
                        {isCompTypeDefault()===true && 
                        <div>
                        {!isNonAuthPerson() && 
                        <div>
                            {isMobile === false?
                            <Field id={'Doc'} name={'Doc'} label={'An image of your signature \n'+getAuthPerName()}
                                isTooltipImg={true}
                                tooltipPosition={'right'} tooltipAchor={'target'} tooltipTitle={'Sign in black on white piece of paper.'}
                                tooltipDesc={config.EnableSignatureCropping? uploadConfig.label.signTTip:uploadConfig.label.signTTipWOCrop}
                                component={FormUploadView} 
                                disabled={buttonPopup}
                                defaultFiles={selectedSignature}
                                onChange={onHandleChange} 
                                isFileUploaded={isSaveSignDone && uploadedSignature? true:false}
                                uploadedFileName={isSaveSignDone && uploadedSignature? uploadedSignature.name:''}
                                onViewClick={e => {
                                    e.preventDefault();
                                    getUploadFile(response.RefNum,typeSignature,signatureId);
                                }} />
                            :
                            <CusSignPad sigPadRef={sigPad}
                                showViewBtn={isSaveSignDone && uploadedSignature? true:false}
                                onClickCear={clearSignPad}
                                onClickSave={saveSignPad}
                                onClickView={handleViewSignImg}
                            />
                            }

                            {uploadSignErr && 
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <Error id={'errId1'}>{signErrMsg}</Error> 
                                </div>
                            </div>}
                        </div>}
                        <FieldWrapper>
                        <CusRadioButton name="AdoptAcraTemplate" leftValue='Y' rightValue='N' 
                            label={'Your company adopts the Standard ACRA template constitution'} 
                            disabled={!isFirstUser()} 
                            onChange={onAdoptAcraTemplateChange} checkedValue={checkedAdoptAcraTemplate} />
                        </FieldWrapper>

                        {checkedAdoptAcraTemplate !==null && <div>
                        <Field id={'PdfDoc'} name={'PdfDoc'} component={FormUploadView} defaultFiles={selectedPdf}
                            disabled={!isFirstUser()}
                            label={'Certified true copies of Memorandum & Articles of Association (M&A)/ By-Laws/ Constitution'}
                            isTooltipImg={false} tooltipPosition={'right'} tooltipAchor={'target'} 
                            tooltipTitle={'You may upload your file in a pdf format (up to 5 MB).'}
                            onChange={onHandlePdfDocChange}
                            isFileUploaded={isSavePdfDone && uploadedPdf? true:false}
                            uploadedFileName={isSavePdfDone && uploadedPdf? uploadedPdf.name:''}
                            onViewClick={e => {
                                e.preventDefault();
                                let oriPdfName = uploadedPdf.name;
                                let pdfNameArray = oriPdfName.split('.');
                                const pdfName = pdfNameArray[0];
                                downloadPdf(response.RefNum,typeMemorandum,pdfId,pdfName)
                            }} />
                            {uploadPdfErr && 
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <Error id={'errId1'}>{pdfErrMsg}</Error> 
                                </div>
                            </div>} 

                        <FieldWrapper>
                        <Field name={'DocClare'} label={uploadConfig.label.declare}  id={'termsinput'}
                            component={TermsFormCheckboxNoErrMsgDisplay} validator={uploadTermsValidator} value={true}/>
                        </FieldWrapper>
                        </div>}
                        </div>}
                        {isCompTypeDefault() === false && <div>
                        {!isNonAuthPerson()? 
                        <div>
                        {isMobile === false? 
                        <Field id={'Doc'} name={'Doc'} label={'An image of your signature \n'+getAuthPerName()}
                            isTooltipImg={true}
                            tooltipPosition={'right'} tooltipAchor={'target'} tooltipTitle={'Sign in black on white piece of paper.'}
                            tooltipDesc={config.EnableSignatureCropping? uploadConfig.label.signTTip:uploadConfig.label.signTTipWOCrop}
                            component={FormUploadView} 
                            disabled={buttonPopup}
                            defaultFiles={selectedSignature}
                            onChange={onHandleChange}
                            isFileUploaded={isSaveSignDone && uploadedSignature? true:false}
                            uploadedFileName={isSaveSignDone && uploadedSignature? uploadedSignature.name:''}
                            onViewClick={e => {
                                e.preventDefault();
                                getUploadFile(response.RefNum,typeSignature,signatureId);
                            }} /> 
                            :
                            <CusSignPad sigPadRef={sigPad}
                                showViewBtn={isSaveSignDone && uploadedSignature? true:false}
                                onClickCear={clearSignPad}
                                onClickSave={saveSignPad}
                                onClickView={handleViewSignImg}
                            />
                            }
                            {uploadSignErr && 
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <Error id={'errId1'}>{signErrMsg}</Error> 
                                </div>
                            </div>}
                        </div>:
                        <FieldWrapper>
                            <Field component={CusFormLabel} 
                                leftLabelId={'lbldisplay'} leftLabelName={'Not applicable'}
                                id={'lbldisplay'} name={''} />
                        </FieldWrapper>}
                        </div>}

                        <FieldWrapper>
                        <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} />

                        <div className="row around-xs inputPair elementVisible">
                            <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{paddingBottom: "20px"}}>
                                <button type={"button"} className="btn btn-back" 
                                    onClick={handleBackBtnClick}>{config.btnName.Back}</button>
                                <button type={'submit'} className="k-button btn btn-success btn-float-right" disabled={disabledNextBtn() || !formRenderProps.valid} >{config.btnName.Next}</button>
                            </div>
                        </div> 
                        </FieldWrapper>
                    </fieldset>
                    {isUploading && <Loading />}
                </FormContainer>
        
                <ImgPopup popupTitle={uploadedSignature? uploadedSignature.name:'Preview'} popupValue={showImgPopup} data={imgStr} setTrigger={setShowImgPopup}  />
                {buttonPopup &&
                <div className='popup-container'>
                    <div className='popup-container-inner'>
                    <div className='popup-container-inner-dot'>
                       <ReactCrop 
                           src={upImg} 
                           onImageLoaded={onLoad} 
                           ruleOfThirds={true}
                           crop={crop}
                           onChange={(c) => setCrop(c)}
                           onComplete={(c) => setCompletedCrop(c)}>
                        </ReactCrop>
                    </div>
                   
                    <div className='inputPairSubTitle'>
                        <div>{signFile.length !==0? signFile[0].name:''} </div>
                        <div>Please crop your signature clearly. Then, click on the <b>Save</b> button to proceed</div>
                        <br/>
                        {!completedCrop? null: <div>{'Cropped image dimension: '+ completedCrop.width.toFixed()+'x'+completedCrop.height.toFixed()}</div>}
                    </div>
                    <div className="row">
                        <div className="col-6" style={{ textAlign: "left"}}>                        
                            <Button look="outline" className="btSize1" onClick={cancelImgCrop}>Cancel</Button>
                        </div> 
                        <div className="col-6" style={{ textAlign: "right"}}>                        
                            <Button primary={true}  className="btSize1 btRht greenbtn2" disabled={!completedCrop?.width || !completedCrop?.height} onClick={saveImgCrop}>Save</Button>
                        </div>
                    </div>
                     
                    </div>
                </div>}
                <div style={{visibility:'hidden'}}>
                    <canvas
                           ref={previewCanvasRef}
                           // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
                           style={{
                           width: Math.round(completedCrop?.width ?? 0),
                           height: Math.round(completedCrop?.height ?? 0)
                       }} />
                </div>  
            </FormElement>
            
            )}>
           </Form>
           <CusToast trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} />
        </div>
    )
}

export default NSUploadDetails